<template>
  <div class="LoginCardComponent">
    <div class="login-card">
      <el-card>
        <div class="welcome-txt">Welcome to StockAnts</div>
        <div class="text-center" v-if="websiteUserType.userType == 'broker'">
          <div class="login-red-txt">
            Login
            <span v-if="websiteUserType.userSubType != 'brokerWithoutPlans'">and subscribe</span>
            for more details
          </div>

          <img src="../assets/images/Login Icon (1).svg" alt="" />
          <br />
          <el-button size="mini" class="btn-secondary-theme-borderd" style="width: 170px" @click="$router.push('/login')">
            <i class="el-icon-lock"></i>
            Login
          </el-button>
        </div>

        <div v-else>
          <div class="bottom-margin-10">
            <div
              class="form-group"
              :class="{
                'not-empty': username.length,
                'form-group--error': show_error_on_empty && !isValidMobileNumber,
              }"
              style="margin-bottom: 5px"
            >
              <div style="display: flex; align-items: center; gap: 5px">
                <!-- Country Code Dropdown -->
                <el-select 
  v-model="selectedCountryCode" 
  v-if="!emailUsername" 
  placeholder="Code" 
  size="small" 
  style="width: 140px; background-color: #f5f7fa" 
  filterable 
  :popper-class="'dropdown-with-search'" 
  class="custom-select" 
  :disabled="is_otp_sent"
>
  <template #prefix>
    <span v-if="selectedCountry">
      <img :src="selectedCountry.flag" alt="flag" style="width: 20px; height: 15px; margin-right: 5px; padding-top:8px; vertical-align: middle;" />
    </span>
  </template>
  
  <el-option 
    v-for="country in countryCodes" 
    :key="`${country.country_code}-${country.name}`" 
    :label="`${country.country_code}`" 
    :value="country.country_code"
  >
    <span class="custom-label" style="display: flex; align-items: center">
      <img :src="country.flag" alt="flag" style="width: 20px; height: 15px; margin-right: 8px; vertical-align: middle" />
      <span style="margin-right: 8px">{{ country.country_code }}</span>
      {{ country.name }}
    </span>
  </el-option>
</el-select>

                <!-- Username Input -->
                <el-input v-model="username" size="small" type="text" class="form-control" placeholder="Mobile number or Email ID" name="user" @input="validateMobileNumber" :disabled="is_otp_sent" style="flex-grow: 1"></el-input>
              </div>
            </div>
            <!-- Validation Error Messages -->
            <div class="error" v-if="show_error_on_empty && !username">Field is required</div>
            <div class="error" v-if="show_error_on_empty && !$v.username.emailOrPhone">Please enter a valid Mobile number or Email ID</div>
            <div class="error" v-if="!isValidMobileNumber">Mobile number must be {{ getMaxLength() }} digits for the selected country</div>
          </div>

          <div class="bottom-margin-10" v-if="is_otp_sent">
            <div
              class="form-group"
              :class="{
                'not-empty': mobile_otp.length,
                'form-group--error': show_error_on_empty && $v.mobile_otp.$error,
              }"
            >
              <el-input type="text" size="small" class="form-control" placeholder="Mobile OTP" v-model="mobile_otp" @input="setMobileOtp($event)"></el-input>
            </div>
            <div class="error" v-if="show_error_on_empty && !$v.mobile_otp.required">Field is required</div>
          </div>

          <div class="input-group-section" v-if="emailUsername">
            <div
              class="form-group"
              :class="{
                'not-empty': password.length,
                'form-group--error': show_error_on_empty && $v.password.$error,
              }"
              style="margin-bottom: 5px; position: relative"
            >
              <img v-if="show_password" src="../assets/images/visibility.png" class="password-visibility" @click="show_password = !show_password" />
              <img v-else src="../assets/images/eye.png" @click="show_password = !show_password" class="password-visibility" />

              <el-input v-model="password" size="small" :type="show_password ? 'text' : 'password'" class="form-control" placeholder="Password" name="pass" @input="setPassword($event)" v-on:keyup.enter="login()"></el-input>
            </div>
            <div class="error" v-if="show_error_on_empty && !$v.password.required">Field is required</div>
          </div>

          <div class="flex-space-between top-margin-15">
            <el-button v-if="mobileUsername && !is_otp_sent" class="btn-secondary-theme-filled" size="mini" style="width: 100%" v-on:click="generateOtp()" :loading="is_login_btn_loading">Generate OTP</el-button>
            <el-button v-else-if="mobileUsername && is_otp_sent" class="btn-secondary-theme-filled" size="mini" style="width: 100%" v-on:click="verifyOtp()" :loading="is_login_btn_loading">Verify OTP</el-button>
            <el-button v-else class="btn-secondary-theme-filled" size="mini" style="width: 100%" v-on:click="login()" :loading="is_login_btn_loading">Log In</el-button>
          </div>
          <div style="font-size: 12px; font-weight: 500; margin-top: 5px; text-align: left">
            Don't have an account?
            <span class="external-link-color" style="text-decoration: underline; cursor: pointer" @click="signUp()">Signup</span>
          </div>

          <div v-if="emailUsername" class="label-color top-margin-10 text-right font-weight-500" style="font-size: 0.7rem; cursor: pointer; color: #2d2e8d; width: 103px; margin-left: auto" @click="goToLink('/forgot-password')">Forgot password?</div>

          <div class="flex-space-between font-07rem top-margin-5" v-if="mobileUsername && is_otp_sent">
            <div style="color: #2d2e8d; cursor: pointer; font-weight: 500" @click="resetUserName()">Change Number</div>
            <div style="color: #2d2e8d; cursor: pointer; font-weight: 500" @click="generateOtp()">Resend OTP</div>
          </div>

          <div class="text-center top-margin-5">
            <div style="width: 40%; display: inline-block; border-bottom: 1px solid #ddd"></div>
            <div style="width: 10%; display: inline-block; font-size: 0.8rem; color: #9b9898; position: relative; top: 4px">Or</div>
            <div style="width: 40%; display: inline-block; border-bottom: 1px solid #ddd"></div>
          </div>

          <div class="top-margin-15 font-07rem google-btn" style="cursor: pointer" ref="googleSignIn">
            <span style="color: #000" class="flex-center">
              <img src="../assets/images/login/google.png" style="width: 20px; margin-right: 5px" />
              Continue with Google
            </span>
          </div>

          <div class="font-08rem font-weight-600 cursor-pointer text-center top-margin-20" style="text-decoration: underline; color: #2d2e8d" @click="loginWithBroker()">Login with Broker</div>
        </div>
      </el-card>
    </div>

    <div id="video-section">
      <el-dialog :visible.sync="videoDialog" :before-close="videoDialogClose" center>
        <div class="iframe-container">
          <iframe id="videoId" width="100%" height="600px" src="https://www.youtube.com/embed/umwESJwcelY?si=J6GKzIUX_MBTJqYp" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
  
  <script>
import { serverAddr, serverHostName } from '../networkConfig';
import CripNotice from 'crip-vue-notice';
import { credentials, cashfreeCredentials } from '../mixins/Credentials.js';
import cashfreePromise from '../mixins/cashfreeInit.js';
import moment from 'moment';
import { required, minLength, maxLength } from 'vuelidate/lib/validators';
import { loginNetworkCallBack } from '../mixins/login.NetworkCallback';

export default {
  name: 'LoginCardComponent',
  props: ['isSentimentCard'],
  mixins: [loginNetworkCallBack],
  data() {
    return {
      password: '',
      moment: moment,
      videoDialog: false,
      credentials: credentials,
      userProfile: null,
      access_code: '',
      currentEnvironment: {},
      accessCodePopup: false,
      qr_loading: false,
      access_code_verification_loading: false,
      websiteUserType: localStorage.getItem('websiteUserType') ? JSON.parse(localStorage.getItem('websiteUserType')) : {},
      isMonthlyPlan: false,
      subscription_agreement: false,
      selectedMarketOption: ['Equity', 'Options'],
      order_id: '',
      currentQRCode: '',
      serverHostName: serverHostName,
      QRTimeout: null,
      mobile_otp: '',
      mobile_number: '',
      isQRvalid: false,
      is_otp_sent: false,
      show_error_on_empty: false,
      update_profile_details_notiifcation_dialog: false,
      intervalId: null,
      session_id: null,
      username: '',
      emailUsername: false,
      mobileUsername: false,
      is_login_btn_loading: false,
      show_password: false,
      currentUrl: localStorage.getItem('currentUrl') ? localStorage.getItem('currentUrl') : window.location.href,
      isValidMobileNumber: true,
      selectedCountryCode: '+91',
      countryCodes: [
        {
          name: 'India',
          country_code: '+91',
          flag: require('@/assets/images/Country-flags/India.svg'),
          length: 10,
        },
        {
          name: 'Singapore',
          country_code: '+65',
          flag: require('@/assets/images/Country-flags/Singapore.svg'),
          length: 8,
        },
        {
          name: 'United States',
          country_code: '+1',
          flag: require('@/assets/images/Country-flags/United States.svg'),
          length: 10,
        },
        {
          name: 'Canada',
          country_code: '+1',
          flag: require('@/assets/images/Country-flags/Canada.svg'),
          length: 10,
        },
        {
          name: 'Dubai',
          country_code: '+971',
          flag: require('@/assets/images/Country-flags/Dubai.svg'),
          length: 9,
        },
        {
          name: 'Saudi Arabia',
          country_code: '+966',
          flag: require('@/assets/images/Country-flags/Saudi Arabia.svg'),
          length: 9,
        },
        {
          name: 'Oman',
          country_code: '+968',
          flag: require('@/assets/images/Country-flags/Oman.svg'),
          length: 8,
        },
        {
          name: 'United Kingdom',
          country_code: '+44',
          flag: require('@/assets/images/Country-flags/United Kingdom.svg'),
          length: 10,
        },
        {
          name: 'Australia',
          country_code: '+61',
          flag: require('@/assets/images/Country-flags/Australia.svg'),
          length: 9,
        },
      ],
    };
  },

  validations() {
    const emailOrPhone = (value) => {
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
      const phonePattern = /^\d{10}$/; // Adjust pattern for different formats if needed
      return emailPattern.test(value) || phonePattern.test(value);
    };

    return {
      username: {
        required,
        emailOrPhone,
      },
      password: {
        required,
      },

      mobile_otp: {
        required,
      },
    };
  },

  watch: {
    username(newValue, oldValue) {
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
      const phonePattern = /^\d{10}$/; // Adjust pattern for different formats if needed

      this.is_otp_sent = false;
      if (emailPattern.test(this.username)) {
        this.emailUsername = true;
      } else if (phonePattern.test(this.username)) {
        this.mobileUsername = true;
      } else {
        this.mobileUsername = false;
        this.emailUsername = false;
      }

      return emailPattern.test(this.username) || phonePattern.test(this.username);
    },

    password(newValue, oldValue) {
      // let regularExpression = /^(?=.*[a-zA-Z])(?=.*[0-9]).+$/;
      let regularExpression = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/;
      if (newValue && this.sign_up_form) {
        if (regularExpression.test(newValue)) {
          this.password_regex_error = false;
          // if(newValue == this.confirmPassword){
          //   this.password_not_matched_error = false;
          // }
        } else {
          this.password_regex_error = true;
        }
      }
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.$nextTick(() => {
        const buttonRef = this.$refs.googleSignIn;
        if (buttonRef) {
          setTimeout(() => {
            window.gapi.load('auth2', () => {
              let element = this.$refs['googleSignIn'];

              const auth2 = window.gapi.auth2.init({
                // WILL NEED TO CHANGE BEFORE MAKING LIVE
                // client_id: "929805204561-vop60edk3dh66alqfcvtdnhkhejq9l83.apps.googleusercontent.com",
                client_id: '1091584009811-nch10s2crqsonpr1vvp58hgof9eqsgnd.apps.googleusercontent.com',
                scope: 'email openid',
                cookiepolicy: 'single_host_origin',
              });

              auth2.attachClickHandler(
                element,
                {},
                (googleUser) => {
                  var profile = googleUser.getBasicProfile();

                  var postData = {
                    username: profile.getEmail(),
                    sign_up_source: 'GMAIL',
                    token: googleUser.getAuthResponse().id_token,
                    referral_code: this.referral_code ? this.referral_code : '',
                    full_name: profile.getName(),
                    first_name: profile.getGivenName(),
                    last_name: profile.getFamilyName(),
                    profession: this.userType == 'Market Expert' ? 'MARKET_EXPERT' : 'RETAIL_INVESTOR',
                  };

                  if (this.currentEnvironment && this.currentEnvironment.isStockAntsAuth) {
                    postData.broker_id = Number(localStorage.getItem('selected_broker'));
                  }

                  serverAddr
                    .post('/auth/v1/sign_in_with_social', postData)
                    .then((response) => {
                      this.socialLoginUserNetworkCallBack(response, profile.getEmail());
                    })
                    .catch(function (error) {
                      console.log(error);
                    });
                },
                (error) => console.log(error)
              );
            });

            window.fbAsyncInit = function () {
              FB.init({
                appId: '1292261177910148',
                // appId      : '938002080014163',
                cookie: true,
                xfbml: true,
                version: 'v8.0',
              });

              FB.AppEvents.logPageView();
            };

            (function (d, s, id) {
              var js,
                fjs = d.getElementsByTagName(s)[0];
              if (d.getElementById(id)) {
                return;
              }
              js = d.createElement(s);
              js.id = id;
              js.src = 'https://connect.facebook.net/en_US/sdk.js';
              fjs.parentNode.insertBefore(js, fjs);
            })(document, 'script', 'facebook-jssdk');
          }, 500);
        }
      });
    });

    this.userProfile = localStorage.getItem('profile') ? JSON.parse(localStorage.getItem('profile')) : null;

    this.currentEnvironment = localStorage.getItem('currentEnvironment') ? JSON.parse(localStorage.getItem('currentEnvironment')) : {};

    this.websiteUserType = localStorage.getItem('websiteUserType') ? JSON.parse(localStorage.getItem('websiteUserType')) : {};

    this.$store.commit('commitQRCodePopup', false);
  },

  methods: {
    signUp() {
      this.$router.push({ name: 'login', params: { plan: 'register' } });
    },
    // Get the max length for the selected country code
    getMaxLength() {
      const selectedCountry = this.countryCodes.find((country) => country.country_code === this.selectedCountryCode);
      return selectedCountry ? selectedCountry.length : 10; // Default to 10 if country is not found
    },
    // Validate the mobile number length
    validateMobileNumber() {
      const maxLength = this.getMaxLength();
      this.isValidMobileNumber = this.username.length === maxLength;
    },
    goToLink(link) {
      this.$router.push(link);
    },
    loginWithBroker() {
      this.$store.commit('commitBrokerLoginDialogVisibility', true);
    },
    setUsername(value) {
      this.username = value;
    },
    setMobileOtp(value) {
      this.mobile_otp = value;
      this.$v.mobile_otp.$touch();
    },

    setPassword(value) {
      this.password = value;
      this.$v.password.$touch();
    },

    login() {
      var authType = '';
      if (this.userType == 'Retail Investor') {
        authType = 'RETAIL_INVESTOR';
      } else if (this.userType == 'Market Expert') {
        authType = 'MARKET_EXPERT';
      }

      this.show_error_on_empty = true;
      this.$v.$touch();
      if (this.username.trim() && this.password) {
        this.is_login_btn_loading = true;
        serverAddr
          .post('/auth/v1/sign_in', {
            username: this.username,
            password: this.password,
            sign_in_with: 'EMAIL',
            profession: authType,
          })
          .then(this.loginUserNetworkCallBack)
          .catch(
            function (error) {
              console.log(error);
              this.is_login_btn_loading = false;
            }.bind(this)
          );
      }
    },

    resetUserName() {
      this.show_error_on_empty = false;
      this.is_otp_sent = false;
      this.username = '';
    },

    async generateOtp() {
      this.$v.username.$touch();

      this.mobile_otp = '';
      this.show_error_on_empty = true;
      this.is_login_btn_loading = true;

      if (this.username.trim().length && this.mobileUsername) {
        this.is_verify_otp_btn_loading = true;
        try {
          const response = await serverAddr.post('/auth/v1/generate_mobile_otp', {
            mobile: this.username,
            country_code: this.selectedCountryCode,
            purpose: 'SIGN_IN',
          });
          if (response.data.status) {
            this.is_otp_sent = true;
            new CripNotice({
              title: 'Success',
              description: response.data.validation,
              type: 'success',
              duration: 3,
            });
          } else {
            if (response.data.message.includes('Account not found')) {
              this.$router.push({
                name: 'login',
                params: { plan: 'register' },
              });
            }
          }
          this.is_login_btn_loading = false;
        } catch (error) {
          console.error('Error generating OTP:', error);
          new CripNotice({
            title: 'Error',
            description: 'Please enter valid OTP',
            type: 'error',
            duration: 3,
          });
          this.is_login_btn_loading = false;
        } finally {
          this.is_verify_otp_btn_loading = false;
        }
      }
    },

    async verifyOtp() {
      this.show_error_on_empty = true;
      this.$v.mobile_otp.$touch();

      if (this.mobile_otp.trim().length) {
        this.is_verify_otp_btn_loading = true;
        try {
          const response = await serverAddr.post('/auth/v1/validate_otp_and_perform_signin_signup', {
            mobile: this.username,
            country_code: this.selectedCountryCode,
            mobile_otp: Number(this.mobile_otp),
            purpose: 'SIGN_IN',
          });
          if (response.data.status) {
            this.verifyOtpNetworkCallBack(response);
            // Add logic for successful OTP verification
          } else {
            this.show_error_on_empty = false;
            this.mobile_otp = '';
          }
        } catch (error) {
          console.error('Error verifying OTP:', error.validation);
          new CripNotice({
            title: 'Error',
            description: error.validation,
            type: 'error',
            duration: 3,
          });
        } finally {
          this.is_verify_otp_btn_loading = false;
        }
      }
    },

    videoDialogClose() {
      this.videoDialog = false;
      let video = document.getElementById('videoId');
      let url = video.getAttribute('src');
      video.setAttribute('src', '');
      video.setAttribute('src', url);
    },
  },
  computed: {
    selectedCountry() {
    return this.countryCodes.find(country => country.country_code === this.selectedCountryCode);
  },
    // returns selected market details from live price ticker component
    selectedMarketType() {
      return this.$store.state.selected_market_type;
    },

    qRCodePopup: {
      get() {
        return this.$store.state.isQRcodePopupVisible;
      },
      set(value) {
        this.$store.commit('commitQRCodePopup', value);
      },
    },

    subscribedPlanDetails() {
      return JSON.parse(localStorage.getItem('plan_details'));
    },

    qrTimeoutMinutes() {
      return this.QRTimeout ? -this.QRTimeout.minutes() : 0;
    },
    qrTimeoutSeconds() {
      return this.QRTimeout ? -this.QRTimeout.seconds() : 0;
    },
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  },
};
</script>
  
  <style lang="scss" scoped>
@import '../css/variable.scss';
@import '../css/common.scss';

.LoginCardComponent {
  .login-card {
    width: 370px;

    .welcome-txt {
      font-size: 18px;
      font-weight: 600;
      margin: 10px 10px 20px;
      text-align: center;
    }
  }

  .password-visibility {
    position: absolute;
    right: 10px;
    top: 9px;
    width: 15px;
    cursor: pointer;
    z-index: 1;
  }
  .google-btn {
    color: rgb(0, 0, 0);
    padding: 12px;
    border: 1px solid #cdcdcd;
    border-radius: 4px;
    font-weight: 500;
    font-size: 13px;
  }
  .btn-secondary-theme-filled {
    padding: 10px 20px;
    background: rgb(0, 0, 0);
    background: linear-gradient(0deg, rgba(0, 0, 0, 1) 0%, rgba(45, 46, 141, 1) 100%);
  }

  //   1080px
  @media screen and (max-width: 1080px) {
  }
}
</style>

<style lang="scss">
@import '../css/variable.scss';
@import '../css/common.scss';

.LoginCardComponent {
  .login-card {
    .el-card {
      border-radius: 15px;
      .el-card__body {
        padding: 20px 30px;
      }
    }
  }

  @media screen and (max-width: 550px) {
    .login-card .el-card .el-card__body {
      padding: 15px 10px;
    }
  }
}
</style>
  